/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Button from "../../components/button";
import ICCheckbox from "../../components/form/checkbox";
import Anchor from "../../components/anchor";
import Label from "../../components/label";

const DoctorSignUpPart2 = props => {
  const formik = useFormik({
    initialValues: {
      serviceAggrement: false,
      verificationProcess: false,
      bothProcess: false,
      legallyProvide: false
    },
    validationSchema: Yup.object({
      serviceAggrement: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ).required('Please check the above points'),
      verificationProcess: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ).required('Please check the above points'),
      bothProcess: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ).required('Please check the above points'),
      legallyProvide: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ).required('Please check the above points')
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="col-sm-12 custom-chk-lbl">
        <ICCheckbox
          id="serviceAggrement"
          name="serviceAggrement"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.serviceAggrement}
          inputProps={{ "aria-label": "I have read and understood the " }}
          label="I have read and understood the "
        />
        <Anchor
          title="Service Agreement"
          href={props.docsUrls ? props.docsUrls.serviceAgreement : ''}
          className="insta-link-orange font-14"
          target="_blank"
        />
      </div>

      <div className="col-sm-12 custom-chk-lbl">
        <ICCheckbox
          name="verificationProcess"
          id="verificationProcess"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.verificationProcess}
          inputProps={{ "aria-label": "I have read and understood the " }}
          label="I have read and understood the "
        />
        <Anchor
          title="Verification Process"
          // href={otherLinks.verificationProcess}
          href={props.docsUrls ? props.docsUrls.validationProcess : ''}
          className="insta-link-orange font-14"
          target="_blank"
        />
      </div>

      <div className="col-sm-12 custom-chk-lbl">
        <ICCheckbox
          name="bothProcess"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.bothProcess}
          inputProps={{ "aria-label": "I am in agreement with the " }}
          label="I am in agreement with the "
        />
        <Anchor
          title="Service Agreement"
          // href={otherLinks.serviceAggrement}
          href={props.docsUrls ? props.docsUrls.serviceAgreement : ''}
          className="insta-link-orange font-14"
          target="_blank"
        />
        <Label
          title=" and "
          className="gray small ml-1 mr-1 middle pt-0 mt-0"
        />
        <Anchor
          title="Verification Process"
          // href={otherLinks.serviceAggrement}
          href={props.docsUrls ? props.docsUrls.validationProcess : ''}
          className="insta-link-orange font-14"
          target="_blank"
        />
      </div>

      <div className="col-sm-12 custom-chk-lbl">
        <ICCheckbox
          name="legallyProvide"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.legallyProvide}
          inputProps={{
            "aria-label":
              "I am legally able to provide telehealth medical service to patients in Australia"
          }}
          label="I am legally able to provide telehealth medical service to patients in Australia"
        />
      </div>         
      {(formik.errors.serviceAggrement && formik.touched.serviceAggrement) ||
      (formik.errors.verificationProcess && formik.touched.verificationProcess) ||
     (formik.errors.bothProcess &&  formik.touched.bothProcess) ||
      (formik.errors.legallyProvide && formik.touched.legallyProvide) ? (
        <Label
          className="error ml-3"
          title="Please check the above points"
        />
      ) : (
        ""
      )}

      <div className="row mt-4 mb-3">
        <div className="col-sm-12 text-center mt-5 ">
          <Button type="submit" className="ml-3" />
        </div>
      </div>
    </form>
  );
};

export default DoctorSignUpPart2;

DoctorSignUpPart2.defaultProps = {
  serverErrorMsg: ""
};

DoctorSignUpPart2.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
